var exports = {
  "k": "x804f0401--f2da05--container",
};

module.exports = exports;
